import pacote from "../../package.json"

const autor =
  typeof pacote.author === "string"
    ? { name: pacote.author, email: undefined, url: undefined }
    : pacote.author

/** Informações do projeto/autor expostas na interface (fonte: package.json). */
export const appInfo = {
  nome: pacote.name,
  versao: pacote.version,
  descricao: pacote.description,
  autor: autor.name,
  email: autor.email ?? "",
  site: autor.url ?? pacote.homepage ?? "",
  linkedin: pacote.linkedin ?? "",
}
